import React from 'react';
import { ResponsiveLayout } from '@/components/ResponsiveLayout';
import { Badge } from '@/components/ui/badge';

export default function ChannelCampaignPage() {
  return (
    <ResponsiveLayout><div className="flex-1 min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      
      <main className="flex-1 px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="mb-6">
          <h1 className="text-4xl font-bold font-heading text-[#F8F9FA] mb-2">
            Channel Campaign
          </h1>
          <p className="text-[#ADB5BD]">Campaign Management per IB</p>
        </div>
        <div className="space-y-4">
          <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-xl font-semibold">New Year Promo 2025</h3>
                <p className="text-sm text-[#ADB5BD]">Main Campaign</p>
              </div>
              <Badge className="bg-[#06D6A0]/20 text-[#06D6A0] border border-[#06D6A0]/40">In Progress</Badge>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <p className="text-xs text-[#ADB5BD]">Health Score</p>
                <p className="text-xl font-mono text-[#06D6A0]">85/100</p>
              </div>
              <div>
                <p className="text-xs text-[#ADB5BD]">KPI Target</p>
                <p className="text-xl font-mono text-[#F8F9FA]">500 Leads</p>
              </div>
              <div>
                <p className="text-xs text-[#ADB5BD]">Current</p>
                <p className="text-xl font-mono text-[#F8F9FA]">342</p>
              </div>
              <div>
                <p className="text-xs text-[#ADB5BD]">Timeline</p>
                <p className="text-sm text-[#F8F9FA]">Jan 1-31</p>
              </div>
            </div>
          </div>
          
          <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-xl font-semibold">Signal VIP Launch</h3>
                <p className="text-sm text-[#ADB5BD]">Sub Campaign</p>
              </div>
              <Badge className="bg-[#FFB703]/20 text-[#FFB703] border border-[#FFB703]/40">Planned</Badge>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <p className="text-xs text-[#ADB5BD]">Health Score</p>
                <p className="text-xl font-mono text-[#6C757D]">N/A</p>
              </div>
              <div>
                <p className="text-xs text-[#ADB5BD]">KPI Target</p>
                <p className="text-xl font-mono text-[#F8F9FA]">100 VIP</p>
              </div>
              <div>
                <p className="text-xs text-[#ADB5BD]">Current</p>
                <p className="text-xl font-mono text-[#F8F9FA]">0</p>
              </div>
              <div>
                <p className="text-xs text-[#ADB5BD]">Timeline</p>
                <p className="text-sm text-[#F8F9FA]">Feb 1-28</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    </ResponsiveLayout>
  );
}
